import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ClassifyFormWrapperComponent } from '../form-wrapper/form-wrapper.component';
import { 
  CategoryFormConfig,
  CATEGORY_HEADER_ACTIONS,
  CATEGORY_PROPERTY_TABLE_SECTION,
  getCategoryFormFields
} from '../../models/classify.config';
import { TextNormalizerService } from '@shared/services/text-normalizer.service';

@Component({
  selector: 'app-classify-view',
  standalone: true,
  imports: [ClassifyFormWrapperComponent],
  templateUrl: './classify-view.component.html',
  styleUrls: ['./classify-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassifyViewComponent {
  private textNormalizer = inject(TextNormalizerService);
  
  config: CategoryFormConfig = {
    title: 'goods.classify.form.view.title',
    formFields: getCategoryFormFields(this.textNormalizer),
    tableSections: [CATEGORY_PROPERTY_TABLE_SECTION],
    headerActions: CATEGORY_HEADER_ACTIONS,
    listRoute: '/goods/classify',
  };
}
